class Contact {

    constructor() {
        this.events();
    }

    events() {
        return $(document).ready(() => {
            return $('#success-modal').modal('show');
        });
    }
}

export default Contact;
